// Fonction pour importer toutes les images d'un dossier spécifique
export const importServiceImages = (serviceName) => {
  try {
    // Cette fonction sera remplacée par un require.context au build time
    const context = require.context(
      '../assets/images/services',
      true,
      /\.(png|jpe?g|svg|webp)$/i
    );
    
    // Récupérer toutes les clés (chemins des fichiers)
    const keys = context.keys();
    
    // Filtrer les images du service demandé et les importer
    const images = keys
      .filter(key => key.includes(serviceName))
      .map(context);
    
    return images;
  } catch (error) {
    console.error(`Erreur lors de l'importation des images pour ${serviceName}:`, error);
    return [];
  }
};

// Fonction utilitaire pour obtenir une image aléatoire d'un service
export const getRandomServiceImage = (serviceName) => {
  const images = importServiceImages(serviceName);
  if (images.length === 0) return null;
  return images[Math.floor(Math.random() * images.length)];
};
